/**
 * Utility functions for handling user roles
 */

// Role mapping from backend values to display names
export const ROLE_DISPLAY_NAMES = {
  doctor: 'Doctor',
  assistant: 'Asistente',
  // Legacy mappings for backward compatibility
  'Médico': 'Doctor',
  'Administrativo': 'Asistente'
};

// Available roles for forms
export const AVAILABLE_ROLES = [
  { value: 'doctor', label: 'Doctor' },
  { value: 'assistant', label: 'Asistente' }
];

/**
 * Get the display name for a role
 * @param {string} role - The role value from the backend
 * @returns {string} The display name for the role
 */
export const getRoleDisplayName = (role) => {
  if (!role) return 'Usuario';
  return ROLE_DISPLAY_NAMES[role] || role;
};

/**
 * Check if a role is a doctor role
 * @param {string} role - The role value
 * @returns {boolean} True if the role is a doctor role
 */
export const isDoctorRole = (role) => {
  return role === 'doctor' || role === 'Médico';
};

/**
 * Check if a role is an assistant role
 * @param {string} role - The role value
 * @returns {boolean} True if the role is an assistant role
 */
export const isAssistantRole = (role) => {
  return role === 'assistant' || role === 'Administrativo';
};

/**
 * Normalize legacy role values to new format
 * @param {string} role - The role value (could be legacy)
 * @returns {string} The normalized role value
 */
export const normalizeRole = (role) => {
  if (role === 'Médico') return 'doctor';
  if (role === 'Administrativo') return 'assistant';
  return role || 'doctor';
};
